<script>
import { mapActions } from 'vuex';
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter';

export default {
  name: 'StatusesFilter',

  extends: BaseSelectFilter,

  methods: {
    ...mapActions('smarthome', ['getSmartHomeDeviceStatuses']),

    getData() {
      return this.getSmartHomeDeviceStatuses().then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
